import { useQueryClient, useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import {
  TemplateForm,
  type TemplateFormData,
} from "~/components/templates/template-form";
import { Button } from "~/components/ui/button";
import { $updateTemplate } from "~/lib/mutations";
import { $getPromptTemplate } from "~/lib/queries";

export const Route = createFileRoute(
  "/(authenticated)/dashboard/settings/templates/$templateId/edit",
)({
  component: EditTemplatePage,
});

function EditTemplatePage() {
  const { templateId } = Route.useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { data: template } = useSuspenseQuery({
    queryKey: ["prompt-template", templateId],
    queryFn: () => $getPromptTemplate({ data: { id: templateId } }),
  });

  const handleSubmit = async (formData: TemplateFormData) => {
    await $updateTemplate({ data: { id: templateId, ...formData } });
    queryClient.invalidateQueries({ queryKey: ["prompt-template", templateId] });
    queryClient.invalidateQueries({ queryKey: ["prompt-templates"] });
    navigate({
      to: "/dashboard/settings/templates/$templateId",
      params: { templateId },
    });
  };

  return (
    <div className="">
      <div className="mb-4">
        <Button
          variant="outline"
          size="icon"
          onClick={() => navigate({ to: "/dashboard/settings/templates" })}
        >
          <ArrowLeft className="h-4 w-4" />
        </Button>
      </div>
      <h1 className="mb-6 text-3xl font-bold">Edit Template</h1>
      <TemplateForm template={template} onSubmit={handleSubmit} />
    </div>
  );
}
